import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { whmcsCurrency } from '@app/core';
import { AuthState } from '@app/core/auth/states/auth.state';
import { AppConfigurationState } from '@app/features/app-content/states/app-configuration.state';
import { UiModule } from '@app/ui';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { combineLatest, filter, Observable, Subscription } from 'rxjs';
import { PaidPublicationsService } from '../services/paid-publications.service';

@Component({
  selector: 'rk-publication-addon-dialog',
  templateUrl: './publication-addon-dialog.component.html',
  styleUrl: './publication-addon-dialog.component.scss',
  imports: [FontAwesomeModule, UiModule, TranslateModule],
})
export class PublicationAddonDialogComponent implements OnInit, OnDestroy {
  @Select(AuthState.userCurrency)
  currency$: Observable<whmcsCurrency>;

  @Select(AppConfigurationState.currentAppIdPlan)
  currentAppIdPlan$: Observable<number>;

  addOnPrice: string;

  constructor(
    private readonly dialogRef: MatDialogRef<PublicationAddonDialogComponent>,
    private readonly paidPublicationsService: PaidPublicationsService,
  ) {}

  private readonly subscriptions = new Subscription();

  ngOnInit() {
    this.subscriptions.add(
      combineLatest([this.currentAppIdPlan$, this.currency$])
        .pipe(filter(([plan, currency]) => !!plan && !!currency))
        .subscribe(([plan, currency]) => {
          this.addOnPrice = this.paidPublicationsService.getAddonPrice(currency, plan);
        }),
    );
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }

  onClose(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
